import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CreateAccountService } from '../../../../_services/forms/create-account/create-account-service.service';
import {
  FormBaseControlService,
  GTagService,
} from '@mapfre-design-library/src/public_api';
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { ValidateEmailService } from '../../../../_services/signup-process-service/validate-email.service';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { Router , RouterModule } from '@angular/router';
import { UserService } from '../../../../_services/user.service';
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
})
export class ConfirmEmailComponent implements OnInit {
  inputs: any[];
  confirmEmailForm: FormGroup;
  userData;
  constructor(
    private service: CreateAccountService,
    private ipt: FormBaseControlService,
    private router: Router,
    private validateEmailService: ValidateEmailService,
    private errorRedirectionService: ErrorRedirectionService,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private gTagServie: GTagService,
    private translate: TranslateService
  ) {
    this.inputs = service.getconfirmEmailInputs();
  }

  ngOnInit(): void {
    this.confirmEmailForm = this.ipt.toFormGroup(this.inputs);
    this.userData = this.userService.getUserInfoInStorage();
  }

  confirmEmail() {
    let isEmailChanged = false;
    const newEmail = this.confirmEmailForm
      .get('createAc_email')
      .value.trim()
      .toLowerCase();
    let oldEmail = this.userData.userDetails['email'];
    if (oldEmail) {
      oldEmail = oldEmail.trim().toLowerCase();
    }
    this.userData.userDetails['newEmail'] = newEmail;
    this.userService.placeUserInfoInStorage(this.userData);
    this.userService.setCommercialAcFlag(false);
    this.userService.updateUser(this.userData);
    if (oldEmail && newEmail !== oldEmail) {
      isEmailChanged = true;
    }
    this.authenticationService.verifyForUserExists(newEmail).subscribe(
      (resp) => {
        if (resp) {
          this.router.navigate(['signup', 'account-exists']);
        } else {
          this.triggerSendValidationEmail(newEmail, oldEmail, isEmailChanged);
        }
      },
      () => {
        this.triggerSendValidationEmail(newEmail, oldEmail, isEmailChanged);
      }
    );
  }

  triggerSendValidationEmail(newEmail, oldEmail, isEmailChanged) {
    this.validateEmailService
      .sendValidationEmailForNonCommercial(newEmail, oldEmail, isEmailChanged)
      .subscribe(
        () => {
          this.gTagServie.triggerFormLink('confirmEmailForm', 'true', '');
          this.userData.userDetails['isEmailEntered'] = true;
          this.userService.placeUserInfoInStorage(this.userData);
          this.router.navigate(['/signup', 'validate-account']);
        },
        (error) => {
          this.gTagServie.triggerFormLink(
            'confirmEmailForm',
            'false',
            this.translate.instant('CONFIRM_EMAIL_VERIFICATION_ERROR')
          );
          this.errorRedirectionService.errorHandler(
            error,
            'VERIFICATION_EMAIL_ERROR'
          );
        }
      );
  }
}
